import React, { Fragment } from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
// router components
import { Link, withRouter } from 'react-router-dom';
import logo from '../../logo.svg';

function NavbarDesign(props) {
    
    //console.log(props.location); // routing restituisce l'url
    let styleAdmin, styleSearch, styleWallpapers;
    
    switch (props.location.pathname) {
        case '/':
            styleAdmin = { color: '#5BD5DE' };
            break;
        case '/admin':
            styleAdmin = { color: '#5BD5DE' };
            break;
        case '/search':
            styleSearch = { color: '#5BD5DE' };
            break;
        case '/wallpapers':
            styleWallpapers = { color: '#5BD5DE' }
            break;
        default:
            break;
    }
    

    return(
            <Fragment>
            <Navbar bg="dark" variant="dark" className="bg-light justify-content-between" expand="md">
                    <Link className="navbar-brand" to="/admin">
                    <img
                        alt=""
                        src={logo}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                    />
                    {props.title}
                    </Link>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <Link className="nav-link" to="/" style={styleAdmin}>Home</Link>
                            <Link className="nav-link" to="/search" style={styleSearch}>Search</Link>
                            <Link className="nav-link" to="/wallpapers" style={styleWallpapers}>Wallpapers</Link>
                            
                            <Button onClick={props.actionLogout} >Logout</Button>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Fragment>
        );
}

export default withRouter(NavbarDesign);